/**
 * Centralized dashboard configuration
 * Maps permissions to routes and display labels
 */
export interface DashboardConfig {
  route: string;
  permission: string;
  label: string;
}

export const DASHBOARD_CONFIGS: DashboardConfig[] = [
  {
    route: '/dashboard',
    permission: 'insight_dashboard',
    label: 'Insights Dashboard',
  },
  {
    route: '/energy-usage-dashboard',
    permission: 'energy_usage_dashboard',
    label: 'Energy Dashboard',
  },
  {
    route: '/optimise',
    permission: 'optimise_dashboard',
    label: 'Perse Analytics',
  },
  {
    route: '/monthly-sales-dashboard',
    permission: 'Monthly_Sales_report',
    label: 'Monthly Sales Dashboard',
  },
];

/**
 * Get route path for a given permission
 */
export function getRouteForPermission(permission: string): string | undefined {
  return DASHBOARD_CONFIGS.find((config) => config.permission === permission)
    ?.route;
}

/**
 * Get permission for a given route path
 */
export function getPermissionForRoute(routePath: string): string | undefined {
  // Remove leading slash if present for comparison
  const normalizedPath = routePath.startsWith('/')
    ? routePath.substring(1)
    : routePath;
  return DASHBOARD_CONFIGS.find(
    (config) =>
      config.route === `/${normalizedPath}` || config.route === normalizedPath,
  )?.permission;
}
